import React from 'react';
import Link from 'next/link';
import { Lock, ArrowLeft } from 'lucide-react';

interface OwnersOnlyLockedProps {
  title?: string;
  description?: string;
  backHref?: string;
  backLabel?: string;
}

export default function OwnersOnlyLocked({
  title = 'Owners Only',
  description = 'This content is reserved for verified unit owners at Panorama Towers. Ownership verification is required to access this section.',
  backHref,
  backLabel = 'Go back',
}: OwnersOnlyLockedProps) {
  return (
    <div className="flex flex-col items-center justify-center py-20 px-6 text-center">
      <div
        className="w-20 h-20 rounded-full flex items-center justify-center mb-6"
        style={{
          background: 'rgba(76,201,255,0.06)',
          border: '1px solid rgba(76,201,255,0.18)',
          boxShadow: '0 0 40px rgba(76,201,255,0.06)',
        }}
      >
        <Lock size={28} style={{ color: '#4CC9FF' }} />
      </div>

      <div
        className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full mb-5"
        style={{ background: 'rgba(76,201,255,0.06)', border: '1px solid rgba(76,201,255,0.15)' }}
      >
        <div className="w-1.5 h-1.5 rounded-full" style={{ background: '#4CC9FF' }} />
        <span className="text-[11px] font-semibold tracking-wide" style={{ color: '#4CC9FF' }}>
          Owners Only
        </span>
      </div>

      <h2 className="font-display font-bold text-[22px] sm:text-[26px] mb-3" style={{ color: '#F2F4FF' }}>
        {title}
      </h2>
      <p className="text-[14px] leading-relaxed max-w-sm mb-8" style={{ color: '#A7A3C4' }}>
        {description}
      </p>

      <div
        className="w-full max-w-sm p-4 rounded-xl mb-8"
        style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.06)' }}
      >
        <p className="text-[13px] leading-relaxed" style={{ color: 'rgba(167,163,196,0.65)' }}>
          If you are a verified owner and believe you should have access, your verification status may need to be updated. Contact the community team for assistance.
        </p>
      </div>

      {backHref && (
        <Link
          href={backHref}
          className="inline-flex items-center gap-2 btn-secondary px-5 py-2.5 text-[13.5px]"
        >
          <ArrowLeft size={14} />
          {backLabel}
        </Link>
      )}
    </div>
  );
}
